if (!customElements.get('quickbuy-widget')) {
  customElements.define('quickbuy-widget', class QuickbuyWidget extends HTMLElement {
    connectedCallback() {
      const optionSelectNodes = Array.from(this.querySelectorAll('[data-option-select]'));
      this.optionSelects = optionSelectNodes.map(node => node.tagName === 'SELECT' ? node : node.querySelector('select')).filter(Boolean);
      this.mainSelect = this.querySelector('[data-main-select]');
      this.addButton = this.querySelector('[data-action="add-to-cart"]');
      this.color = this.dataset.color ? this.dataset.color.trim() : '';

      this.normalize = value => String(value || '').trim();
      this.key = value => this.normalize(value).toLowerCase().replace(/[^a-z0-9]+/g, '');
      this.labelKey = text => String(text || '').replace(/\s+/g, ' ').trim();
      this.getSelectName = select => this.normalize(select.getAttribute('name') || select.getAttribute('id') || select.dataset.optionName || '');
      this.getSelectedLabel = select => {
        const selectedIndex = select ? select.selectedIndex : -1;
        const selectedOption = selectedIndex >= 0 ? select.options[selectedIndex] : null;
        return this.labelKey(selectedOption ? (selectedOption.textContent || selectedOption.innerText || selectedOption.value || '') : '');
      };

      this.sizeSelect = this.optionSelects.find(select => /size/i.test(this.getSelectName(select))) || this.optionSelects.find(select => select.querySelector('option[data-select-reminder]')) || null;

      this.handleChange = this.handleChange.bind(this);
      this.addEventListener('change', this.handleChange);

      this.addEventListener('change', () => {
        if (!this.mainSelect) return;
        const selectedLabels = this.optionSelects.map(select => this.getSelectedLabel(select));
        const combinedLabel = this.labelKey(selectedLabels.join('-'));
        Array.from(this.mainSelect.options).forEach(option => {
          const label = this.labelKey(option.innerText || option.textContent);
          if (label === combinedLabel) {
            option.setAttribute('selected', 'selected');
            this.mainSelect.value = option.value;
          } else {
            option.removeAttribute('selected');
          }
        });
      });

      this.syncVariant();
      this.updateAddButtonState();
      this.autoselectFromCart();
    }

    handleChange() {
      this.syncVariant();
      this.updateAddButtonState();
    }

    syncVariant() {
      if (!this.mainSelect) return;
      const selectedLabels = this.optionSelects.map(select => this.getSelectedLabel(select));
      const combinedLabel = this.labelKey(selectedLabels.join('-'));
      let matchedOption = null;
      for (const option of Array.from(this.mainSelect.options || [])) {
        const label = this.labelKey(option.textContent || option.innerText);
        const isMatch = label === combinedLabel;
        option.selected = isMatch;
        if (isMatch) matchedOption = option;
      }
      if (matchedOption) this.mainSelect.value = matchedOption.value;
    }

    updateAddButtonState() {
      if (!this.addButton) return;
      let shouldDisable = false;
      for (const select of this.optionSelects) {
        const selectedIndex = select.selectedIndex;
        const selectedOption = selectedIndex >= 0 ? select.options[selectedIndex] : null;
        if (!selectedOption || selectedOption.disabled || selectedOption.hasAttribute('data-select-reminder')) {
          shouldDisable = true;
          break;
        }
      }
      this.addButton.disabled = shouldDisable;
    }

    optionMatch(select, desiredValue) {
      const desiredKey = this.key(desiredValue);
      return Array.from(select.options || []).find(option => {
        if (option.disabled) return false;
        if (option.hasAttribute('data-select-reminder')) return false;
        const optionValueKey = this.key(option.value);
        const optionTextKey = this.key(option.textContent || '');
        return optionValueKey === desiredKey || optionTextKey === desiredKey;
      }) || null;
    }

    matchesSelectName(select, optionName) {
      const selectNameKey = this.key(this.getSelectName(select));
      const optionNameKey = this.key(optionName);
      if (!optionNameKey) return false;
      if (selectNameKey === optionNameKey) return true;
      if (selectNameKey.includes(optionNameKey) || optionNameKey.includes(selectNameKey)) return true;
      const dataNameKey = this.key(select.dataset.optionName || '');
      if (dataNameKey && (dataNameKey === optionNameKey || dataNameKey.includes(optionNameKey) || optionNameKey.includes(dataNameKey))) return true;
      return false;
    }

    async autoselectFromCart() {
      let cartData;
      try {
        const response = await fetch('/cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) return;
        cartData = await response.json();
      } catch { return; }

      const cartItems = Array.isArray(cartData?.items) ? cartData.items : [];
      const validCategories = new Set(['footwear', 'insole', 'sock']);
      const matchingItems = cartItems.filter(item => validCategories.has(String(item?.properties?._category || '').toLowerCase()));
      if (!matchingItems.length) return;

      const firstItem = matchingItems[0];
      const optionPairs = Array.isArray(firstItem?.options_with_values) ? firstItem.options_with_values : [];
      const normalizedPairs = optionPairs.map(opt => ({
        name: this.normalize(opt?.name),
        value: this.normalize(opt?.value)
      })).filter(pair => pair.name && pair.value);

      for (const { name, value } of normalizedPairs) {
        let targetSelect = this.optionSelects.find(select => this.matchesSelectName(select, name));
        if (!targetSelect) targetSelect = this.optionSelects.find(select => !!this.optionMatch(select, value));
        if (!targetSelect) continue;
        const matchedOption = this.optionMatch(targetSelect, value);
        if (!matchedOption) continue;
        targetSelect.value = matchedOption.value;
        targetSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      this.syncVariant();
      this.updateAddButtonState();
    }
  });
}
